import { restRequest } from 'plugins/request';
import { QUERY_KEY_SPECIAL_PROJECTS } from './index';

// Utils
export { QUERY_KEY_SPECIAL_PROJECTS };

export const specialProjects = restRequest(QUERY_KEY_SPECIAL_PROJECTS);

export type SPData = {
  items: any;
  image: string;
  modulId: number;
  s3?: string;
  translation?: object;
};

export const apiGetSpecialProjects = async (
  params: { [x: string]: any; modulId?: number },
  locale: string | undefined,
  modulId: number
): Promise<SPData> => {
  const { ...otherParams } = params;

  return await specialProjects.get('', false, false, {
    ...otherParams,
    lang: `${locale}`,
    modul_id: modulId,
    content: '',
    sort: '',
    limit: 6,
    translationData: 'title,image,id',
  });
};
